//@ts-ignore
import { useMemo } from "react";
import { useUser } from "../../../../keycloak";
import { NavItem } from "./Navitem/Navitem";
import DCS_LOGO from "../../../../assets/DCS.png";

import styles from "./sidebar.module.scss";
import { UserRoles } from "../../../../constants/userRoles";
import { Menu } from "./types";
import { ReportId, reportsMapping, ANALYTICS_REPORTS } from "../../../../constants/constants";

const envMap: {
  [key: string]: string;
} = {
  localhost: "LOCAL",
  "dev-www": "DEV",
  "uat-www": "UAT",
};

export const Sidebar = () => {
  const user: any = useUser();

  const sideBarMenu = useMemo(() => {
    if (user) {
      const roles = user.roles.dcs_client || [];
      
      const menu: Menu = [
        ...(roles.includes(UserRoles.PROFILE_VIEW)
          ? [
              {
                label: "Profile",
                to: "/profile",
                icon: "pi-user",
              },
            ]
          : []),
        {
          label: "CRM/SALES",
          to: "/sales",
          icon: "pi-chart-bar",
          children: [
            ...(roles.includes(UserRoles.LEAD_VIEW)
              ? [
                  {
                    label: "Leads",
                    to: "leads",
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.CONTRACT_VIEW)
              ? [
                  {
                    label: "Contracts",
                    to: "contract",
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.CLIENT_VIEW)
              ? [
                  {
                    label: "Clients",
                    to: "client",
                  },
                ]
              : []),
          ],
        },
        {
          label: "HR Management",
          to: "/management",
          icon: "pi-users",
          children: [
            ...(roles.includes(UserRoles.USER_VIEW)
              ? [
                  {
                    label: "Employees",
                    to: "employees",
                  },
                ]
              : []),
          ],
        },
        {
          label: "Billing & Payment",
          to: "/billing",
          icon: "pi-wallet",
          children: [],
        },
        {
          label: "Scheduling & Execution",
          to: "/scheduling-execution",
          icon: "pi-calendar-plus",
          children: [
            ...(roles.includes(UserRoles.JOB_VIEW)
              ? [
                  {
                    label: "Schedule",
                    to: "schedule",
                  },
                ]
              : []),
          ],
        },
        {
          label: "Reports",
          to: "/reports",
          icon: "pi-chart-line",
          children: [
            ...(roles.includes(UserRoles.TIME_CARD_ACTIVITY_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.DailyTimeCards],
                    to: ReportId.DailyTimeCards,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.TIME_CARD_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.TimeCards],
                    to: ReportId.TimeCards,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.TIME_ANALYSIS_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.TimeAnalysis],
                    to: ReportId.TimeAnalysis,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.ACTIVITY_DETAIL_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.EmployeeActivityDetail],
                    to: ReportId.EmployeeActivityDetail,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.OVER_FORTY_HOURS_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.OverFortyHoursCheck],
                    to: ReportId.OverFortyHoursCheck,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.LATE_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.LateEmployees],
                    to: ReportId.LateEmployees,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.LATE_NO_SHOW_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.LateNoShowEmployees],
                    to: ReportId.LateNoShowEmployees,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.JOB_SUMMARY_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.JobSummary],
                    to: ReportId.JobSummary,
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.ACTUAL_VS_SCHEDULED_VIEW)
              ? [
                  {
                    label: reportsMapping[ReportId.JobActualVsSchedule],
                    to: ReportId.JobActualVsSchedule,
                  },
                ]
              : []),
              ...(roles.includes(UserRoles.WORKFORCE_DASHBOARD)
              ? [
                  {
                    label: reportsMapping[ReportId.WorkforceDashboard],
                    to: ReportId.WorkforceDashboard,
                  },
                ]
              : []),
          ],
        },
        ...(roles.includes(UserRoles.POWER_BI_VIEW)
          ? [
              {
                label: "Analytics",
                to: "/analytics",
                icon: "pi-chart-pie",
                // NOTE: children are sourced from the static ANALYTICS_REPORTS constant rather than
                // GET /analytics/reports to avoid an async call in the sidebar. If per-report
                // permissions are added (i.e., individual reports get different requiredPermission
                // values), update this to fetch from the API so role-based filtering is applied.
                children: ANALYTICS_REPORTS.map((r) => ({
                  label: r.name,
                  to: r.id,
                })),
              },
            ]
          : []),
        {
          label: "Administration",
          to: "/administration",
          icon: "pi-user-edit",
          children: [
            ...(roles.includes(UserRoles.PROJECT_TYPE_VIEW)
              ? [
                  {
                    label: "Leads Form",
                    to: "leads-form",
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.CONTRACT_TYPE_VIEW)
              ? [
                  {
                    label: "Contract type",
                    to: "contract-type",
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.JOB_ZONE_VIEW)
              ? [
                  {
                    label: "Service Division",
                    to: "service-division",
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.INVENTORY_VIEW)
              ? [
                  {
                    label: "Inventory",
                    to: "Inventory",
                  },
                ]
              : []),
            ...(roles.includes(UserRoles.INTEGRATION_VIEW)
              ? [
                  {
                    label: "Integrations",
                    to: "integrations",
                  },
                ]
              : []),
          ],
        },
      ];

      return menu;
    }

    return [];
  }, [user]);

  let subDom: any = window.location.hostname.split(".")[0]; // this is temp solution because we dont have env detection

  return (
    <nav className={styles.sidebar}>
      <div className={styles.logoContainer}>
        <img src={DCS_LOGO} alt="DCS logo" />
        {/* <span>{envMap[subDom]}</span> */}
      </div>
      {sideBarMenu.map((item, index) => {
        return <NavItem key={`${item.label}-${index}`} item={item} />;
      })}
    </nav>
  );
};
